import { render, staticRenderFns } from "./ProjectValuationScoreFinalTable.vue?vue&type=template&id=b2b5be4a&scoped=true&"
import script from "./ProjectValuationScoreFinalTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreFinalTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationScoreFinalTable.vue?vue&type=style&index=0&id=b2b5be4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b5be4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
